import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-cyber-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2459)">
        <path
          d="M13.5 18.75C13.5854 20.3578 14.1037 21.9126 15 23.25H9C9.89635 21.9126 10.4146 20.3578 10.5 18.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 23.25H17.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 15.75H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.25 15.75V17.25C23.25 17.6478 23.092 18.0294 22.8107 18.3107C22.5294 18.592 22.1478 18.75 21.75 18.75H2.25C1.85218 18.75 1.47064 18.592 1.18934 18.3107C0.908035 18.0294 0.75 17.6478 0.75 17.25V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.75 5.25H15.75C14.9216 5.25 14.25 5.92157 14.25 6.75V11.25C14.25 12.0784 14.9216 12.75 15.75 12.75H21.75C22.5784 12.75 23.25 12.0784 23.25 11.25V6.75C23.25 5.92157 22.5784 5.25 21.75 5.25Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 5.25V3.75C15.75 2.95435 16.0661 2.19129 16.6287 1.62868C17.1913 1.06607 17.9544 0.75 18.75 0.75C19.5456 0.75 20.3087 1.06607 20.8713 1.62868C21.4339 2.19129 21.75 2.95435 21.75 3.75V5.25"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.75 8.625C18.6758 8.625 18.6033 8.64699 18.5417 8.6882C18.48 8.72941 18.4319 8.78797 18.4035 8.8565C18.3752 8.92502 18.3677 9.00042 18.3822 9.07316C18.3967 9.1459 18.4324 9.21272 18.4848 9.26517C18.5373 9.31761 18.6041 9.35333 18.6768 9.3678C18.7496 9.38226 18.825 9.37484 18.8935 9.34646C18.962 9.31807 19.0206 9.27001 19.0618 9.20834C19.103 9.14667 19.125 9.07417 19.125 9C19.1251 8.95072 19.1155 8.9019 19.0967 8.85634C19.0779 8.81078 19.0503 8.76939 19.0155 8.73454C18.9806 8.69969 18.9392 8.67208 18.8937 8.65328C18.8481 8.63448 18.7993 8.62487 18.75 8.625Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 6.75L6.75 11.25L4.5 9"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2459">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessCyberInsuranceIconComponent extends BaseIconComponent {}
